/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Classes } from "@blueprintjs/core";
var NS = Classes.getClassNamespace();
export var DATEINPUT = "".concat(NS, "-dateinput");
export var DATEINPUT_POPOVER = "".concat(DATEINPUT, "-popover");
export var DATEPICKER = "".concat(NS, "-datepicker");
export var DATEPICKER_CAPTION = "".concat(DATEPICKER, "-caption");
export var DATEPICKER_CAPTION_CARET = "".concat(DATEPICKER_CAPTION, "-caret");
export var DATEPICKER_CAPTION_MEASURE = "".concat(DATEPICKER_CAPTION, "-measure");
export var DATEPICKER_CAPTION_SELECT = "".concat(DATEPICKER_CAPTION, "-select");
export var DATEPICKER_CONTENT = "".concat(DATEPICKER, "-content");
export var DATEPICKER_DAY = "DayPicker-Day";
export var DATEPICKER_DAY_DISABLED = "".concat(DATEPICKER_DAY, "--disabled");
export var DATEPICKER_DAY_OUTSIDE = "".concat(DATEPICKER_DAY, "--outside");
export var DATEPICKER_DAY_SELECTED = "".concat(DATEPICKER_DAY, "--selected");
export var DATEPICKER_DAY_IS_TODAY = "".concat(DATEPICKER_DAY, "--isToday");
export var DATEPICKER_DAY_WRAPPER = "".concat(DATEPICKER, "-day-wrapper");
export var DATEPICKER_FOOTER = "".concat(DATEPICKER, "-footer");
export var DATEPICKER_MONTH_SELECT = "".concat(DATEPICKER, "-month-select");
export var DATEPICKER_YEAR_SELECT = "".concat(DATEPICKER, "-year-select");
export var DATEPICKER_NAVBAR = "".concat(DATEPICKER, "-navbar");
export var DATEPICKER_NAVBUTTON = "DayPicker-NavButton";
export var DATEPICKER_TIMEPICKER_WRAPPER = "".concat(DATEPICKER, "-timepicker-wrapper");
export var DATERANGEPICKER = "".concat(NS, "-daterangepicker");
export var DATERANGEPICKER_CONTIGUOUS = "".concat(DATERANGEPICKER, "-contiguous");
export var DATERANGEPICKER_SINGLE_MONTH = "".concat(DATERANGEPICKER, "-single-month");
export var DATERANGEPICKER_DAY_SELECTED_RANGE = "".concat(DATEPICKER_DAY, "--selected-range");
export var DATERANGEPICKER_DAY_HOVERED_RANGE = "".concat(DATEPICKER_DAY, "--hovered-range");
export var DATERANGEPICKER_SHORTCUTS = "".concat(DATERANGEPICKER, "-shortcuts");
export var DATERANGEPICKER_TIMEPICKERS = "".concat(DATERANGEPICKER, "-timepickers");
export var DATETIMEPICKER = "".concat(NS, "-datetimepicker");
export var TIMEPICKER = "".concat(NS, "-timepicker");
export var TIMEPICKER_ARROW_BUTTON = "".concat(TIMEPICKER, "-arrow-button");
export var TIMEPICKER_ARROW_ROW = "".concat(TIMEPICKER, "-arrow-row");
export var TIMEPICKER_DIVIDER_TEXT = "".concat(TIMEPICKER, "-divider-text");
export var TIMEPICKER_HOUR = "".concat(TIMEPICKER, "-hour");
export var TIMEPICKER_INPUT = "".concat(TIMEPICKER, "-input");
export var TIMEPICKER_INPUT_ROW = "".concat(TIMEPICKER, "-input-row");
export var TIMEPICKER_MILLISECOND = "".concat(TIMEPICKER, "-millisecond");
export var TIMEPICKER_MINUTE = "".concat(TIMEPICKER, "-minute");
export var TIMEPICKER_SECOND = "".concat(TIMEPICKER, "-second");
export var TIMEPICKER_AMPM_SELECT = "".concat(TIMEPICKER, "-ampm-select");
//# sourceMappingURL=classes.js.map